import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import usePrivateLink from "../../config/usePrivateLink";

// import usePrivateLink from "../../config/usePrivateLink";
// import { useNavigate, useLocation } from "react-router-dom";

// const IdCardHeader = ({ data }) => {
//     const navigate = useNavigate();
//     const location = useLocation();

//  const tabs = [
//   {
//     id: "enquiryAdd",
//     title: "Student Id Card",
//     icon: "fa-solid fa-id-card",        
//     path: "/student/id-card"
//   },

//   {
//     id: "todayreport",
//     title: "Staff Id Card",
//     icon: "fa-solid fa-id-badge",      
//     path: "/idcard_staff"
//   },

//   {
//     id: "enquiryfoloup",
//     title: "Student Profile Update",
//     icon: "fa-solid fa-user-pen",       
//     path: "/idcard/student"
//   }
// ];


//     return (
//         <div className="">
//             <div className="list-group shadow-sm mb-3" style={{ minWidth: "260px" }}>
//                 <h5 className="text-primary text-center p-2">{data}</h5>
//                 {tabs.map((tab) => {
//                     const isActive = location.pathname === tab.path;
//                     return (
//                         <button
//                             key={tab.id}
//                             className={`list-group-item list-group-item-action d-flex align-items-center ${isActive ? "active" : ""
//                                 }`}
//                             onClick={() => navigate(tab.path)}
//                         >
//                             <i className={`${tab.icon} me-2`} />
//                             {tab.title}
//                         </button>
//                     );
//                 })}
//             </div>
//         </div>
//     );
// };

// export default IdCardHeader;





const IdCardHeader = ({ data }) => {
  const hasAccess = usePrivateLink();
  const navigate = useNavigate();
  const location = useLocation();
const tabs = [
  {
    id: "enquiryAdd",
    title: "Student Id Card",
    icon: "ri-id-card-line",       
    path: "/student/id-card"
  },

  {
    id: "todayreport",
    title: "Staff Id Card",
      icon: "ri-id-card-fill",  
    path: "/idcard_staff"
  },

  {
    id: "enquiryfoloup",
    title: "Student Profile Update",
    icon: "ri-user-settings-line",   
    path: "/idcard/student"
  }
];


  const filteredTabs = tabs.filter((tab) => hasAccess(tab.path));


  return (
    <div className="">

      {/* ✅ Sidebar Menu */}
      <div className="list-group shadow-sm mb-3" style={{ minWidth: "260px" }}>
        <h5 className="text-primary text-center p-2">{data}</h5>
        {filteredTabs.length === 0 && (
          <div className="text-center text-danger">You don't have permission to access any tabs.</div>
        )}
        {filteredTabs.map((tab) => {
          const isActive = location.pathname === tab.path;
          const permission = hasAccess(tab.path);

          return (
            <button
              key={tab.id}
              className={`list-group-item list-group-item-action d-flex align-items-center ${isActive ? "bg-label-primary" : ""} ${!permission ? "disabled-tab" : ""}`}
              onClick={() => permission && navigate(tab.path)}
              style={{
                cursor: permission ? "pointer" : "not-allowed",
                color: !permission ? "red" : "inherit",
                backgroundColor: !permission ? "#f8d7da" : "inherit",
              }}
              disabled={!permission}
            >
              <i className={`${tab.icon} me-2`} />
              {tab.title}
            </button>
          );
        })}
      </div>

      {/* ✅ Page Content */}
    </div>
  );
};

export default IdCardHeader;





